<div class="mr-20" fxFlex.gt-sm="100" id="emp-selection-employee">
  <mat-form-field floatLabel="always">
    <mat-label>Trabajador</mat-label>
    <input matInput [formControl]="employeeFilter" minlength="4" placeholder="" value="" (keyup)="applyEmployeeFilter()" autocomplete="off">
  </mat-form-field>
  <mat-error *ngIf="employeeFilter.touched || employeeFilter.dirty" >
    <span *ngIf="employeeFilter.errors?.minlength"  class="validation-span">
      Trabajador debe  tener al menos 4 caracteres
    </span>
</mat-error>
</div>

